import vars from "@exovera/narrative-tracker-variables";
import { addOrRemove } from "@exovera/helpers";

import {
	SET_ALLOW_LOCATION_FILTERS_DURING_HIGHLIGHT,
	TOGGLE_DMA_AGGREGATION,
	TOGGLE_DMA_AGGREGATION_LEFT,
	TOGGLE_DMA_AGGREGATION_RIGHT,
	RECEIVE_MAP_DATA,
	SET_CURRENT_MAP_ID,
	SET_FILTER_BY_MAP_COUNTRY,
	SET_MAP_EXPANDED,
	SET_MAP_EXPANDED_LEFT,
	SET_MAP_EXPANDED_RIGHT,
} from "actions/constants.js";

import {
	SEARCH_UPDATE_FILTERS
} from "actions/constants/searchActionTypes.js";

import { 
	addOrRemoveHierarchyFilter,
	deactivateLocationFilters, 
	isolateStateFilter,
	reactivateFilters,
	removeLocationFilters,
	convertMapCodeToEntityFilter,
	parseActiveFilters,
	genCountryFilter,
	hasCountryFilters,
	removeSourceCountryFilters,
	removeStateFilters,
} from "lib/helpers/filterHelpers.js";

import { updateData, updateMapData } from "actions/data.js";
import { updateMapDataCompare } from "actions/dataCompare.js";
import { SEARCH_STATE_IDS } from "actions/constants/stateIds.js";

const stateId = SEARCH_STATE_IDS.NARRATIVES;

export function receiveMapData(params) {
	const { currentFilters, currentMapSegmentSpan, data, fetchKey, filtersList, narrative, perspective, stateCode } = params;
	// console.log("receiveMapData", data, stateCode);
	// Warning if the API response doesn't match the request
	// if (stateCode && stateCode !== data.geoState) {
	// 	console.warn(
	// 		`Map data does not match request. Requested state ${stateCode}; reveived state ${
	// 			data.geoState
	// 		}`
	// 	);
	// }
	return (dispatch, getState) => {
		const { darkUI, projectTheme } = getState().projectConfig;
		dispatch({
			type: RECEIVE_MAP_DATA,
			data,
			narrative,
			perspective,
			filtersList,
			currentFilters,
			currentMapSegmentSpan,
			fetchKey,
			filterColor: projectTheme ? projectTheme.accent : darkUI ? vars.cerulean_1 : vars.cerulean_2,
		});
	};
}

export function incrementMapPosition() {
	return (dispatch, getState) => {
		dispatch({
			type: "incrementMapPosition",
			darkUI: getState().projectConfig.darkUI,
		});
	};
}
export function setMapPosition(segment, index) {
	return {
		type: "setMapPosition",
		segment,
		index,
	};
}

export function clearMapPlay() {
	return (dispatch, getState) => {
		dispatch({
			type: "clearMapPlay",
			darkUI: getState().projectConfig.darkUI,
		});
	};
}
export function toggleMapPlay(playing) {
	return (dispatch, getState) => {
		dispatch({
			type: playing === "playing" ? "stopPlayingMap" : "startPlayingMap",
			darkUI: getState().projectConfig.darkUI,
		});
	};
}

export const toggleDmaAggregation = () => {
	return (dispatch, getState) => {
		const {
			activeKeywords,
			activeNarrativeData,
			contentFilteredByDate,
			currentFiltersList,
			currentMapSegmentSpan,
			currentZoom,
			entityFilters,
			mapHighlightId,
			perspective,
		} = getState().base;

		dispatch({
			type: TOGGLE_DMA_AGGREGATION,
		});

		dispatch(
			updateMapData({
				activeFilters: currentFiltersList,
				contentFilteredByDate,
				currentFiltersList,
				currentZoom,
				entityFilters,
				keywords: activeKeywords,
				nar: activeNarrativeData,
				perspective,
				mapHighlightId,
				updatedMapSegment: currentMapSegmentSpan,
			})
		);
	};
};
export const toggleDmaAggregationLeft = () => {
	return (dispatch, getState) => {
		const {
			activeKeywords,
			activeNarrativeData,
			contentFilteredByDate,
			filtersList,
			currentMapSegmentSpanCompare,
			currentZoom,
			entityFilters,
			mapHighlightId,
			perspective,
		} = getState().leftCompare;
		const { location } = getState().router;

		const eventMode = location && location.pathname === "/events";

		dispatch({
			type: TOGGLE_DMA_AGGREGATION_LEFT,
		});
		dispatch(
			updateMapDataCompare({
				side: "Left",
				activeFilters: filtersList,
				contentFilteredByDate,
				currentZoom,
				entityFilters,
				eventMode,
				keywords: activeKeywords,
				mapHighlightId,
				narrative: activeNarrativeData,
				perspective,
				updatedMapSegment: currentMapSegmentSpanCompare,
			})
		);
	};
};
export const toggleDmaAggregationRight = () => {
	return (dispatch, getState) => {
		const {
			activeKeywords,
			activeNarrativeData,
			contentFilteredByDate,
			filtersList,
			currentMapSegmentSpanCompare,
			currentZoom,
			entityFilters,
			mapHighlightId,
			perspective,
		} = getState().rightCompare;
		const { location } = getState().router;

		const eventMode = location && location.pathname === "/events";

		dispatch({
			type: TOGGLE_DMA_AGGREGATION_RIGHT,
		});
		dispatch(
			updateMapDataCompare({
				side: "Right",
				activeFilters: filtersList,
				contentFilteredByDate,
				currentZoom,
				entityFilters,
				eventMode,
				keywords: activeKeywords,
				mapHighlightId,
				narrative: activeNarrativeData,
				perspective,
				updatedMapSegment: currentMapSegmentSpanCompare,
			})
		);
	};
};

export const selectMapSegmentSpan = (params) => {
	const { span } = params;
	// console.log("selectMapSegmentSpan", span);
	return (dispatch, getState) => {
		const {
			activeKeywords,
			activeNarrativeData,
			contentFilteredByDate,
			currentFiltersList,
			currentZoom,
			entityFilters,
			mapHighlightId,
			perspective,
		} = getState().base;

		dispatch(
			updateMapData({
				activeFilters: currentFiltersList,
				contentFilteredByDate,
				currentFiltersList,
				currentZoom,
				entityFilters,
				keywords: activeKeywords,
				nar: activeNarrativeData,
				perspective,
				mapHighlightId,
				updatedMapSegment: span,
			})
		);
	};
};

//  Map hover
export function hoverMap(data, color, startDate, endDate) {
	return {
		type: "hoverMap",
		data,
		color,
		startDate,
		endDate,
	};
}
export function unhoverMap() {
	return {
		type: "unhoverMap",
	};
}

// Map click
export function clickMap(data, color, isHighlighted, stateFilterParentId) {
	// console.log("clickMap", data, color, isHighlighted, stateFilterParentId);
	return (dispatch, getState) => {
		const {
			activeKeywords,
			activeNarrativeData,
			currentMapSegmentSpan,
			mapHighlightGeoState,
			mapHighlightId,
			perspective,
		} = getState().base;

		const { 
			activeSearchObj, 
			filters,
			currentFiltersList, 
			currentZoom 
		} = getState().search[stateId];

		const { varStore } = getState().storage;

		// Filter enabled Map
		if (stateFilterParentId) {

			const { topicsPie } = getState().projectConfig;
			const { entityFilters } = getState().base;

			// Build new geo state filters
			const { mapLookup } = getState().projectConfig;
			const filterObject = convertMapCodeToEntityFilter({ 
				stateObject: data, 
				parent: stateFilterParentId, 
				mapLookup,
				active: true, 
			});

			// Update filters
			dispatch({
				type: SEARCH_UPDATE_FILTERS,
				stateId: SEARCH_STATE_IDS.NARRATIVES,
				filters: addOrRemoveHierarchyFilter(filters, filterObject)
			});

			// REVISIT JA: NARR
			const newFilters = addOrRemove(currentFiltersList, filterObject, "id");

			dispatch(
				updateData({
					nar: activeNarrativeData,
					perspective,
					// REVISIT JA: NARR
					// currentZoom: varStore.narratives[perspective].currentZoom.begin ? varStore.narratives[perspective].currentZoom : currentZoom,
					currentZoom,
					entityFilters, 
					currentFiltersList,
					activeFilters: newFilters, 
					keywords: activeKeywords,
					mapHighlightId: isHighlighted ? false : data.geoState,
					query: activeSearchObj.query,
					contentFilteredByDate: varStore.narratives[perspective].contentFilteredByDate,
					topicsPie,
				})
			);

		}

		// Non-Filter enabled map
		else {
			const filtersList = varStore.narratives[perspective].filters;
			const cleanFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
			const newFilters = reactivateFilters(cleanFilters, filtersList);
			let countyAlreadyHighlighted;

			// Update UI
			if (isHighlighted) {
				// if a state is highlighted
				countyAlreadyHighlighted = getState().base.mapCountyHighlightId === data.geoState;

				if (countyAlreadyHighlighted) {
					dispatch({ type: "highlightCountyOff" });
				} else {
					// highlight map
					dispatch({ type: "highlightCounty", data, color });
				}
			} else {
				dispatch({ type: "setTooltipShares", topShares: data.shares, topLevel: data.level });

				const { begin, end } = varStore.narratives[perspective].currentZoom;
				dispatch({
					type: "highlightMap",
					data,
					color,
					startDate: begin,
					endDate: end,
				});
			}
			// Need to refetch data for changing highlight
			dispatch(
				updateMapData({
					activeFilters: countyAlreadyHighlighted ? isolateStateFilter(newFilters, mapHighlightGeoState) : isolateStateFilter(newFilters, data),
					contentFilteredByDate: varStore.narratives[perspective].contentFilteredByDate,
					currentFiltersList,
					currentZoom: varStore.narratives[perspective].currentZoom,
					entityFilters: varStore.narratives[perspective].entityFilters,
					keywords: activeKeywords,
					mapHighlightId: isHighlighted ? false : data.geoState,
					nar: activeNarrativeData,
					perspective,
					updatedMapSegment: currentMapSegmentSpan,
				})
			);
		}
	};
}
export function clearMap() {
	return (dispatch, getState) => {
		const {
			activeNarrativeData,
			currentFiltersList,
			currentMapSegmentSpan,
			filters,
			perspective,
			filtersList,
			activeKeywords,
		} = getState().base;
		const { varStore } = getState().storage;
		const { projectMapConfig, topicsPie } = getState().projectConfig;
		const { activeSearchObj, currentZoom } = getState().search[stateId];

		// clear any pre-existing filters due to a map
		if (projectMapConfig) {
			dispatch(
				updateData({
					nar: activeNarrativeData,
					perspective,
					// REVISIT JA: NARR
					// currentZoom: varStore.narratives[perspective].currentZoom,
					currentZoom,
					entityFilters: varStore.narratives[perspective].entityFilters,
					activeFilters: removeLocationFilters(filtersList),
					currentFilters: deactivateLocationFilters(filters),
					keywords: activeKeywords,
					mapHighlightId: null,
					query: activeSearchObj.query,
					contentFilteredByDate: varStore.narratives[perspective].contentFilteredByDate,
					topicsPie,
				})
			);
		} else {
			dispatch(
				updateMapData({
					activeFilters: filtersList,
					contentFilteredByDate: varStore.narratives[perspective].contentFilteredByDate,
					currentFiltersList,
					currentZoom: varStore.narratives[perspective].currentZoom,
					entityFilters: varStore.narratives[perspective].entityFilters,
					keywords: activeKeywords,
					mapHighlightId: null,
					nar: activeNarrativeData,
					perspective,
					updatedMapSegment: currentMapSegmentSpan,
				})
			);
		}

		dispatch({ type: "highlightCountyOff" });
		dispatch({ type: "clearMapHighlight" });
	};
}

export function setAllowLocationFiltersDuringHighlight() {
	return {
		type: SET_ALLOW_LOCATION_FILTERS_DURING_HIGHLIGHT,
	};
}
export function setHighlightableObjects(highlightable) {
	return {
		type: "setHighlightableObjects",
		highlightable,
	};
}

export function setMapExpanded(expanded) {
	return { type: SET_MAP_EXPANDED, expanded };
}

export const setMapExpandedLeft = (expanded) => {
	return (dispatch) => {
		dispatch({ type: SET_MAP_EXPANDED_RIGHT, expanded });
		dispatch({ type: SET_MAP_EXPANDED_LEFT, expanded });
	}
}

export const setMapExpandedRight = (expanded) => {
	return (dispatch) => {
		dispatch({ type: SET_MAP_EXPANDED_RIGHT, expanded });
		dispatch({ type: SET_MAP_EXPANDED_LEFT, expanded });
	}
}

export function changeMap(id, stateIdPrefix) {
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { topicsPie } = getState().projectConfig;
		const { 
			activeKeywords,
			activeNarrativeData,
			currentMapId,
			currentFiltersList,
			filterByMapCountry, 
			perspective,
		} = getState().base;

		const { activeSearchObj, currentZoom } = getState().search[stateId];

		dispatch({
			type: SET_CURRENT_MAP_ID,
			id,
			stateIdPrefix
		});

		if (filterByMapCountry) {
			const filterObject = genCountryFilter({ 
				countryId: id, 
				active: filterByMapCountry, 
			});
			
			let newFilters = removeSourceCountryFilters(currentFiltersList);
			newFilters = addOrRemove(newFilters, filterObject, "id");
			newFilters = removeStateFilters(newFilters, stateIdPrefix);

			dispatch(
				updateData({
					nar: activeNarrativeData,
					perspective,
					// REVISIT JA: NARR
					// currentZoom: varStore.narratives[perspective].currentZoom,
					currentZoom,
					entityFilters: varStore.narratives[perspective].entityFilters,
					activeFilters: newFilters,
					currentFiltersList,
					keywords: activeKeywords,
					mapHighlightId: null,
					query: activeSearchObj.query,
					contentFilteredByDate: varStore.narratives[perspective].contentFilteredByDate,
					topicsPie,
				})
			);
		}
	};
}

export const toggleFilterByMapCountry = () => {
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { topicsPie } = getState().projectConfig;
		const { 
			activeKeywords,
			activeNarrativeData,
			currentMapId,
			currentFiltersList,
			filterByMapCountry, 
			perspective,
			currentMapStateIdPrefix,
		} = getState().base;

		const {
			activeSearchObj,
			currentZoom,
		} = getState().search[stateId];

		const newState = !filterByMapCountry;
		let newFilters = [];
		const filterObject = genCountryFilter({ 
			countryId: currentMapId, 
			active: newState, 
		});

		// If any country filters are set and changing to not filter by
		// displayed map country then clear all active country filters
		if (hasCountryFilters(currentFiltersList) && !newState) {
			newFilters = removeSourceCountryFilters(currentFiltersList);
		}

		// If any country filters are set and changing to filter by
		// displayed map country then remove all current country filters 
		// and replace with a single new country filter for the active map.
		// Also remove any state/province level filters set which are not
		// relevant to the current map country.
		else if (hasCountryFilters(currentFiltersList)) {
			newFilters = removeSourceCountryFilters(currentFiltersList);
			newFilters = addOrRemove(newFilters, filterObject, "id");
			newFilters = removeStateFilters(newFilters, currentMapStateIdPrefix);
		}

		// If no country filters are set and changing to filter by displayed
		// country then add a single new country filter for the active map
		// Also remove any state/province level filters set which are not
		// relevant to the current map country.
		else if (!hasCountryFilters(currentFiltersList) && newState) {
			newFilters = addOrRemove(currentFiltersList, filterObject, "id");
			newFilters = removeStateFilters(newFilters, currentMapStateIdPrefix);
		}

		// Should never be here (no filters set + moving out of a filtered
		// map state), just clear any active country filters
		else {
			newFilters = removeSourceCountryFilters(currentFiltersList);
		}

		// Store changes & send API updates
		dispatch({
			type: SET_FILTER_BY_MAP_COUNTRY,
			value: newState,
		});

		dispatch(
			updateData({
				nar: activeNarrativeData,
				perspective,
				// REVISIT JA: NARR
				// currentZoom: varStore.narratives[perspective].currentZoom,
				currentZoom,
				entityFilters: varStore.narratives[perspective].entityFilters,
				activeFilters: newFilters,
				currentFiltersList,
				keywords: activeKeywords,
				mapHighlightId: null,
				query: activeSearchObj.query,
				contentFilteredByDate: varStore.narratives[perspective].contentFilteredByDate,
				topicsPie,
			})
		);
	};
};
